import './App.css';
import React, { useState, useEffect } from 'react';
import SkillsTreePage from './pages/SkillsTreePage';
import SkillsMatrixPage from './pages/SkillsMatrixPage';
import GradesTablePage from './pages/GradesTablePage';
import SkillEditPage from './pages/SkillEditPage';
import SkillDetailsPage from './pages/SkillDetailsPage';
import StatusBoardPage from './pages/StatusBoardPage';
import { darkPurple } from './utils/colors';

const DEFAULT_CRM_URL = 'https://spaceapp.ru/Deals?type=Active';

function App() {
  const [apiBase, setApiBase] = useState('');
  const [route, setRoute] = useState('skills');
  const shouldRender = useState(() => {
    const url = new URL(window.location.href);
    const tokenFromQuery = url.searchParams.get('token');

    if (tokenFromQuery) {
      sessionStorage.setItem('token', tokenFromQuery);
      window.history.replaceState({}, '', '/');
      return true;
    }

    const token = sessionStorage.getItem('token');
    if (!token) {
      fetch('/config.json')
        .then(res => res.json())
        .then(cfg => {
          window.location.href = cfg.CRM_URL || DEFAULT_CRM_URL;
        })
        .catch(() => {
          window.location.href = DEFAULT_CRM_URL;
        });
      return false;
    }

    return true;
  })[0];

  useEffect(() => {
    fetch('/config.json')
      .then(res => res.json())
      .then(cfg => {
        setApiBase(cfg.REACT_APP_API_URL || '');
      });
  }, []);

  useEffect(() => {
    const apply = () => {
      const full = (window.location.hash || '#/skills');
      if (full.startsWith('#/skill/')) { 
        const skillId = full.replace('#/skill/', '');
        if (skillId.includes('edit')) {
          setRoute('skillEdit'); 
        } else {
          setRoute('skillDetails'); 
        }
        return; 
      }
      const hash = full.replace('#/', '');
      if (hash === 'skills' || hash === 'matrix' || hash === 'grades' || hash === 'board') setRoute(hash);
      else setRoute('skills');
    };
    apply();
    window.addEventListener('hashchange', apply);
    return () => window.removeEventListener('hashchange', apply);
  }, []);

  if (!shouldRender) {
    return null;
  }

  return (
    <div className="App" style={{ background: darkPurple, minHeight: '100vh', padding: 0, display: 'flex', flexDirection: 'column' }}>
      {route === 'skills' && <SkillsTreePage apiBase={apiBase} />}
      {route === 'matrix' && <SkillsMatrixPage apiBase={apiBase} />}
      {route === 'grades' && <GradesTablePage apiBase={apiBase} />}
      {route === 'board' && <StatusBoardPage apiBase={apiBase} />}
      {route === 'skillEdit' && <SkillEditPage apiBase={apiBase} />}
      {route === 'skillDetails' && <SkillDetailsPage apiBase={apiBase} />}
    </div>
  );
}

export default App;

